import React from "react";

const ThreeColCollectionItem = () => {
  return (
    <div className="mx-auto w-full max-w-sm rounded-md border shadow">
      <div className="flex animate-pulse space-x-4">
        <div className="h-[200px] w-full  bg-slate-200"></div>
      </div>
    </div>
  );
};
export const ThreeColCollectionSkeleton = () => {
  let collectionStoriesItems = [1, 2, 3, 4, 5, 6];
  return (
    <div className="grid grid-cols-3 grid-rows-2 gap-x-5 gap-y-5 font-satoshi mobile:flex mobile:flex-col">
      {collectionStoriesItems.map((i) => (
        <ThreeColCollectionItem key={i} />
      ))}
    </div>
  );
};

export const StoryCardSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="aspect-video w-full animate-pulse rounded bg-slate-300"></div>
      <div className="space-y-3">
        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-2 h-2 rounded bg-slate-300"></div>
          <div className="col-span-1 h-2 rounded bg-slate-300"></div>
        </div>
        <div className="h-2 rounded bg-slate-300"></div>
        <div className="h-2 rounded bg-slate-300"></div>
        <div className="h-2 w-[100px] rounded bg-slate-300"></div>
      </div>
    </div>
  );
};

export const TitleCardSkeleton = () => {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-3 gap-4">
        <div className="col-span-2 h-2 rounded bg-slate-300"></div>
        <div className="col-span-1 h-2 rounded bg-slate-300"></div>
      </div>
      <div className="h-2 rounded bg-slate-300"></div>
      <div className="h-2 rounded bg-slate-300"></div>
      <div className="h-2 w-[100px] rounded bg-slate-300"></div>
    </div>
  );
};

export const SpecificSectionSkeleton = () => {
  return (
    <div className="flex w-full gap-4">
      <div className="h-[50%] w-[33.3%]">
        <StoryCardSkeleton />
      </div>
      <div className="h-[50%] w-[33.3%]">
        <StoryCardSkeleton />
      </div>
      <div className="flex w-[33.3%] flex-col gap-10">
        {[1, 2, 3].map((i) => (
          <TitleCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
};

export const SectionImageTitleSkeleton = () => {
  return (
    <div className="flex w-full flex-col gap-4">
      <StoryCardSkeleton />
      <TitleCardSkeleton />
      <TitleCardSkeleton />
    </div>
  );
};

export const HeadlineCardsWideSkeleton = () => {
  return (
    <div className="flex w-full flex-col gap-8">
      <div className="h-[25px] animate-pulse rounded bg-slate-300"></div>
      {[1, 2, 3, 4].map((i) => (
        <TitleCardSkeleton key={i} />
      ))}
    </div>
  );
};
export const TwoColCollectionSkeleton = () => {
  return (
    <div className="flex w-full gap-4">
      <div className="w-[50%]">
        <StoryCardSkeleton />
      </div>
      <div className="flex w-[25%] flex-col gap-8">
        <StoryCardSkeleton />
        <TitleCardSkeleton />
      </div>
      <div className="flex w-[25%] flex-col gap-8">
        <StoryCardSkeleton />
        <TitleCardSkeleton />
      </div>
    </div>
  );
};

export const SingleCollectionSkeleton = () => {
  return (
    <div className="flex gap-3">
      <div className="h-[370px] w-[25%] animate-pulse bg-slate-300"></div>
      <div className="w-[25%]">
        <StoryCardSkeleton />
      </div>
      <div className="w-[25%]">
        <StoryCardSkeleton />
      </div>
      <div className="w-[25%]">
        <StoryCardSkeleton />
      </div>
    </div>
  );
};
